module.exports = __webpack_public_path__ + "img/icon-gis.aba70701.png";